module.exports = __webpack_public_path__ + "static/media/Wheel distance.9bfb9ece.JPG";